import _ from 'underscore';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as naturalSort from '../../../utils/naturalSort';
import TriStateChecklistButton from './triStateChecklistButton';

/* @class TriStateChecklist - this class defines a checklist that can be in
 * three states - 'NONE', 'SOME', or 'ALL'.  We could easily generify this,
 * but until we
 */
export default class TriStateChecklist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: {}
    };
    this.setHover = this.setHover.bind(this);
  }
  setHover(key, hoverState = true) {
    const {
      hover
    } = this.state;
    hover[key] = hoverState;
    this.setState({
      hover
    });
  }

  /* @method createListOptions - this method iterates over the incoming
   *  values (items that have one or more related objects).  If `all` is set
   *  to true on an object, then it is in the STATUS_ALL state, if false,
   *  it is STATUS_SOME state, and if there is not value in the option list,
   *  then is is STATUS_NONE.
   *
   *  Build an output list with these status set, along with other relevant
   *  attributes like the relevant glyph and name associated with the state.
   */
  createListOptions() {
    const opt = {
      [TriStateChecklist.STATUS_NONE]: [],
      [TriStateChecklist.STATUS_ALL]: [],
      [TriStateChecklist.STATUS_SOME]: []
    };
    let {
      options
    } = this.props;
    options = naturalSort.naturalSortBy(options, option => option.name);
    options.map(item => {
      const newItem = _.extend(item);
      const value = this.findValueFromItem(item);
      newItem.status = TriStateChecklist.STATUS_NONE;
      if (value) {
        if (value.all) {
          newItem.status = TriStateChecklist.STATUS_ALL;
        } else {
          newItem.status = TriStateChecklist.STATUS_SOME;
        }
      }
      const {
        glyph,
        title
      } = TriStateChecklist.status[item.status];
      newItem.glyph = glyph;
      newItem.title = title;
      opt[item.status].push(newItem);
      return newItem;
    });
    return opt[TriStateChecklist.STATUS_ALL].concat(opt[TriStateChecklist.STATUS_SOME]).concat(opt[TriStateChecklist.STATUS_NONE]);
  }
  findValueFromItem(item) {
    const {
      values
    } = this.props;
    return _.find(values, obj => obj.id === item.id);
  }
  render() {
    const options = this.createListOptions();
    const ulStyle = {
      listStyleType: 'none'
    };
    const {
      className,
      optionsNameKeyAlt,
      disabled,
      onSelect
    } = this.props;
    const {
      hover
    } = this.state;
    return /*#__PURE__*/React.createElement("ul", {
      style: ulStyle,
      className: `t-tsc ${className}`
    }, options.map(incomingItem => {
      const item = _.clone(incomingItem);
      if (hover[item.id]) {
        item.glyph = TriStateChecklist.nextStatus[item.status].glyph;
      }
      if (!item.name && optionsNameKeyAlt) {
        item.name = item[optionsNameKeyAlt];
      }
      const itemStyle = {
        paddingBottom: '5px',
        paddingTop: '5px',
        bottomBorder: 'solid 1px #ccc'
      };
      return /*#__PURE__*/React.createElement("li", {
        key: item.id,
        style: itemStyle
      }, /*#__PURE__*/React.createElement(TriStateChecklistButton, {
        disabled: disabled,
        isHovering: hover[item.id] || false,
        item: item,
        onHover: this.setHover,
        onSelect: onSelect
      }));
    }));
  }
}
TriStateChecklist.STATUS_NONE = 'NONE';
TriStateChecklist.STATUS_SOME = 'SOME';
TriStateChecklist.STATUS_ALL = 'ALL';
TriStateChecklist.status = {
  [TriStateChecklist.STATUS_ALL]: {
    title: 'All entities have this relationship.',
    glyph: 'check-circle'
  },
  [TriStateChecklist.STATUS_NONE]: {
    title: 'No entities have this relationship.',
    glyph: 'times-circle'
  },
  [TriStateChecklist.STATUS_SOME]: {
    title: 'Some entities have this relationship.',
    glyph: 'minus-circle'
  }
};
TriStateChecklist.nextStatus = {
  [TriStateChecklist.STATUS_ALL]: TriStateChecklist.status[TriStateChecklist.STATUS_NONE],
  [TriStateChecklist.STATUS_NONE]: TriStateChecklist.status[TriStateChecklist.STATUS_ALL],
  [TriStateChecklist.STATUS_SOME]: TriStateChecklist.status[TriStateChecklist.STATUS_ALL]
};
TriStateChecklist.propTypes = {
  // values contains all values that have at least one relevant selection
  values: PropTypes.arrayOf(PropTypes.shape({})),
  // options are all possible values to select.
  options: PropTypes.arrayOf(PropTypes.shape({})),
  // key for options who's 'name' value is falsey
  optionsNameKeyAlt: PropTypes.string,
  // when a new value is selected, this is called with the current value
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
TriStateChecklist.defaultProps = {
  className: '',
  disabled: false,
  options: [],
  optionsNameKeyAlt: null,
  values: []
};